import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, style, ...props }, ref) => {
    const internalRef = React.useRef<HTMLInputElement | null>(null);
    const [isFocused, setIsFocused] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(false);

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-[16px] ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm transition-all duration-200",
          className
        )}
        style={isFocused && isMobile ? { height: '64px', fontSize: '18px', padding: '16px 12px', ...style } : style}
        onFocus={(e) => {
          const mobile = window.innerWidth < 768;
          setIsMobile(mobile);
          setIsFocused(true);
          // Scroll to start of text on focus (mobile)
          if (mobile && internalRef.current) {
            setTimeout(() => {
              internalRef.current?.setSelectionRange(0, 0);
              internalRef.current?.scrollTo({ left: 0 });
            }, 50);
          }
          props.onFocus?.(e);
        }}
        onBlur={(e) => {
          setIsFocused(false);
          setIsMobile(false);
          props.onBlur?.(e);
        }}
        ref={(node) => {
          internalRef.current = node;
          if (typeof ref === 'function') {
            ref(node);
          } else if (ref) {
            ref.current = node;
          }
        }}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
